import { useContext } from 'react';

import { LayoutContext } from '@lcsc-ui/layouts/baseLayout/provider';
import indexBuriedPoint from '@lcsc-ui/utils/_indexBuriedPoint';
import { buriedPoint } from '@lcsc-ui/utils/buriedPoint';
import { styled } from 'styled-components';
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';

const CustomSwiperStyle = styled.section`
  .swiper {
    padding: 0 0 46px 0;
    padding-top: ${({ paddingtopvalue }) => paddingtopvalue + 'px'};
  }
  .swiper-pagination {
    bottom: ${({ bottom }) => bottom + 'px'};
    .swiper-pagination-bullet {
      width: 6px;
      height: 6px;
      background: #0093e6;
    }
  }
`;

const pagination = {
  clickable: true,
};

function groupArray(arr, size) {
  const result = [];
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size));
  }
  return result;
}

const IndexBrandAd = ({ data, isLgScreen, showChildren, children, height, noBorder, bottom, paddingTopValue }) => {
  const pageView = isLgScreen ? 9 : 7;
  const { resourceData } = useContext(LayoutContext);
  if (data) {
    const { brandList } = data;
    if (brandList) {
      const groupedBrandArray = groupArray(isLgScreen ? brandList : brandList.slice(0, 42), 2);
      return (
        <CustomSwiperStyle
          bottom={bottom ? bottom : 30}
          paddingtopvalue={
            paddingTopValue !== null && paddingTopValue !== undefined && paddingTopValue !== '' ? paddingTopValue : 14
          }
          data-spm="pp"
          className={`mx-auto mt-[20px] w-[1200px]  _lg:w-[1552px] px-[20px] bg-white rounded-[20px]`}
          style={{
            height: height ? height : 284,
          }}
        >
          {showChildren ? (
            children
          ) : (
            <div className="flex justify-between items-center pt-[20px]">
              <h2 className="text-[18px] leading-[24px] font-bold">品牌专区</h2>
              <div
                onClick={() => {
                  buriedPoint({
                    cp: 'index_brand',
                    ty: 'click',
                    op: 'brand_library',
                  });
                }}
              >
                <a
                  data-spm="mr"
                  href={`${resourceData?.projectConfigVO.lcscWwwUrl}/brand.html`}
                  target="_blank"
                  className={'text-[#0093e6]'}
                >
                  查看更多
                </a>
              </div>
            </div>
          )}
          <Swiper
            tag="div"
            wrapperTag="ul"
            className="relative"
            key={pageView}
            modules={[Pagination]}
            spaceBetween={16}
            slidesPerView={pageView}
            slidesPerGroup={pageView}
            loop
            pagination={pagination}
          >
            {isLgScreen !== null &&
              groupedBrandArray.map((item, idx) => (
                <SwiperSlide key={item[0].brandName} tag="li">
                  <a
                    data-spm={idx * 2 + 1}
                    href={item[0]?.targetLink}
                    attr-sc={pageView}
                    title={item[0].brandName}
                    target="_blank"
                    onClick={() => indexBuriedPoint('brand_CLICK', item[0]?.targetLink)}
                    className={`w-[152px] h-[85px] inline-block  rounded-[11px] mb-[10px] ${noBorder ? '' : 'border-[1px] border-[#EEEEEE] border-solid'} overflow-hidden box-border`}
                  >
                    <img
                      className="w-[152px] h-[85px] mr-[22px] rounded-[11px] will-change-transform transform duration-300 hover:scale-[1.1] img-pixel"
                      src={item[0].brandUrl}
                      alt={item[0].brandName}
                    />
                  </a>
                  {item[1] && (
                    <a
                      data-spm={idx * 2 + 2}
                      href={item[1]?.targetLink}
                      title={item[1].brandName}
                      target="_blank"
                      onClick={() => indexBuriedPoint('brand_CLICK', item[1]?.targetLink)}
                      className={`w-[152px] h-[85px] inline-block rounded-[11px] mb-[10px] ${noBorder ? '' : 'border-[1px] border-[#EEEEEE] border-solid'} overflow-hidden box-border`}
                    >
                      <img
                        className="w-[152px] h-[85px] mr-[22px] rounded-[11px] will-change-transform transform duration-300 hover:scale-[1.1] img-pixel"
                        src={item[1].brandUrl}
                        alt={item[1].brandName}
                      />
                    </a>
                  )}
                </SwiperSlide>
              ))}
          </Swiper>
        </CustomSwiperStyle>
      );
    }
  }
};

export default IndexBrandAd;
